import { LuxAvatar, LuxTypography, useMediaQuery } from '@gemini/fe-ds-core';
import { Modes } from '@utils/enums/Modes.enum';
import {
  HeaderWrapper,
  TitleAndSubtitleContainer,
  TitleWrapper,
  TypographyDesktop,
  TypographyMobile,
} from './PageHeader.styles';
import { useMemo, useState } from 'react';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useTranslation } from 'react-i18next';
import { IntegrationModes } from '@utils/enums/IntegrationModes.enum';
import { BrandNameList } from '@utils/consts/brandNameList';
import { TabletBreakpoint } from '@utils/consts/breakpoints.consts';

export interface HeaderProps {
  practiceName: string;
  mode: Modes;
  logo: string;
  showLogo?: boolean;
  isForTypWidget?: boolean;
}

const PageHeader = ({
  practiceName,
  mode,
  logo,
  showLogo,
  isForTypWidget = false,
}: HeaderProps) => {
  const { t } = useTranslation();
  const brandName = useOnlineBookingStore(state => state.brandName);
  const integrationMode = useOnlineBookingStore(state => state.integrationMode);
  const isMobile = useMediaQuery(`(max-width:${TabletBreakpoint}px)`);
  const [onErrorLogo, setOnErrorLogo] = useState<boolean>(false);

  const showFakeRONATitleAndSubtitle = useMemo(() => {
    return (
      !!brandName &&
      !!integrationMode &&
      integrationMode === IntegrationModes.STANDALONE
    );
  }, [brandName, integrationMode]);

  return (
    <HeaderWrapper
      role="banner"
      noSignIn={mode === Modes.STANDALONE}
      isForTypWidget={isForTypWidget}
      className="ob-no-print"
      centered={showFakeRONATitleAndSubtitle}
      borderBottom={showFakeRONATitleAndSubtitle}
    >
      <TitleWrapper>
        {showLogo && !onErrorLogo && !brandName && logo && (
          <span aria-hidden="true">
            <LuxAvatar src={logo} onError={() => setOnErrorLogo(true)} />
          </span>
        )}
        {showFakeRONATitleAndSubtitle ? (
          <TitleAndSubtitleContainer>
            <TypographyDesktop variant={'heading3'} component="p">
              {brandName === BrandNameList.LC || brandName === BrandNameList.FE
                ? t('OEEStandaloneHeader.scheduleExamTitle').toUpperCase()
                : t('OEEStandaloneHeader.scheduleExamTitle')}
            </TypographyDesktop>
            <TypographyDesktop
              variant={'textMedium'}
              fontSize={'1rem'}
              fontWeight={400}
            >
              {t('OEEStandaloneHeader.scheduleExamSubtitle')}
            </TypographyDesktop>
          </TitleAndSubtitleContainer>
        ) : (
          <>
            <TypographyDesktop variant={'heading3'} component="p">
              {practiceName}
            </TypographyDesktop>
            <TypographyMobile variant={'heading2'} component="p">
              {practiceName}
            </TypographyMobile>
          </>
        )}
      </TitleWrapper>

      {!isMobile && !showFakeRONATitleAndSubtitle && (
        <LuxTypography variant={'heading2'} component="h1">
          {t('bookingTitle')}
        </LuxTypography>
      )}
    </HeaderWrapper>
  );
};

export default PageHeader;
